import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { createContact } from "../../api/apiUrlConst";
import { toast } from "react-toastify";

function Contactform() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    purpose: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleInitialSubmit = async (e: any) => {
    e.preventDefault();
    try {
      setLoading(true);
      await createContact(formData);

      toast.success("Enquiry submitted successfully!");

      setFormData({
        name: "",
        email: "",
        phoneNumber: "",
        purpose: "",
        message: "",
      });
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: "92.1vh",
        background: "linear-gradient(135deg, #667eea, #764ba2)",
        padding: "40px 15px",
      }}
    >
      <Card
        className="shadow-lg border-0"
        style={{
          maxWidth: "850px",
          width: "100%",
          borderRadius: "20px",
          background: "rgba(255,255,255,0.95)",
        }}
      >
        <CardBody className="p-5">
          <div className="text-center mb-4">
            <h2 style={{ fontWeight: 700 }}>Enquiry Form</h2>
            <p className="text-muted">
              Fill the details and our team will contact you soon
            </p>
          </div>

          <Form onSubmit={handleInitialSubmit}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Full Name *</Label>
                  <Input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label>Email *</Label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Phone *</Label>
                  <Input
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    required
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label>Purpose</Label>
                  <Input
                    type="select"
                    name="purpose"
                    value={formData.purpose}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Purpose</option>
                    <option value="Training">Training</option>
                    <option value="Consulting">Consulting</option>
                    <option value="HR">Human Resource</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label>Message</Label>
              <Input
                type="textarea"
                name="message"
                value={formData.message}
                onChange={handleChange}
              />
            </FormGroup>

            <Button color="primary" type="submit" className="w-100" disabled={loading}>
              {loading ? "Submitting..." : "Submit Enquiry"}
            </Button>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
}

export default Contactform;